import { render, staticRenderFns } from "./moduleEight.vue?vue&type=template&id=1ec0d4a6&scoped=true&"
import script from "./moduleEight.vue?vue&type=script&lang=js&"
export * from "./moduleEight.vue?vue&type=script&lang=js&"
import style0 from "./moduleEight.vue?vue&type=style&index=0&id=1ec0d4a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0d4a6",
  null
  
)

export default component.exports